<template>
  <vx-card class="p-5">
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      finishButtonText="ยืนยัน"
      back-button-text="ย้อนกลับ"
      next-button-text="ถัดไป"
      @on-complete="checkCardNumber"
    >
      <tab-content
        title="ผู้ยืนคำขอ (เจ้าของเรือ)"
        class="mb-5"
      >
        <!-- tab 1 content -->

        <div class="vx-row">
          <div class="vx-col md:w-full w-full mt-5" align="center">
            <div class="box" id="preview">
              <div v-if="idCardImage">
                <img :src="idCardImage" class="img-show" />
              </div>
              <div v-else>
                <img
                  src="../../../assets/icons/cloud-img.png"
                  width="200"
                  height="200"
                />
              </div>
            </div>
            <div>
              <vs-button
                icon-pack="feather"
                icon="icon-upload"
                class="mt-10"
                color="primary"
                @click="$refs.onChangeIdCardImage.click()"
              >
                <span class="d-none d-sm-block">อัปโหลดรูป</span>
              </vs-button>
              <input
                ref="onChangeIdCardImage"
                type="file"
                accept=".jpeg,.png,.jpg,GIF"
                :hidden="true"
                @change="onChangeIdCardImage"
                v-validate="'required'"
                name="cardnumber_image"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('cardnumber_image')"
                >{{ errors.first("cardnumber_image") }}</span
              >
            </div>
          </div>
          <vs-divider position="center">อัปโหลดรูปบัตรประชาชน*</vs-divider>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <div class="flex">
            <vs-select
              :class="[toggleOther == true ? 'w-full mr-5' : 'w-1/2 mr-5']"
              label="คำนำหน้า*"
              v-model="regisInfo.title"
              @change="onOther"
              v-validate="'required'"
              name="title"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.value"
                v-for="(item, index) in title"
              />
            </vs-select>
            <vs-input
              v-show="!toggleOther"
              label="อื่นๆ"
              v-model="regisInfo.other"
              class="w-1/2"
              v-validate="!toggleOther && 'required'"
              name="title"
            />
            </div>
            <span
              class="text-danger text-sm"
              v-show="errors.has('title')"
              >{{ errors.first("title") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ชื่อ*"
              v-model="regisInfo.firstName"
              class="w-full"
              v-validate="'required'"
              maxlength="50"
              name="first_name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('first_name')"
              >{{ errors.first("first_name") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="นามสกุล*"
              v-model="regisInfo.lastName"
              class="w-full"
              v-validate="'required'"
              maxlength="100"
              name="last_name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('last_name')"
              >{{ errors.first("last_name") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              id="card_id"
              label="เลขบัตรประชาชน*"
              v-model="cardNumber"
              class="w-auto"
              v-validate="'required|min:17'"
              maxlength="17"
              name="card_number"
              @change="toggleValidate && checkCardNumber()"
            />
            <span
              v-if="toggleValidate"
              class="text-danger text-sm"
              >เลขบัตรประชาชนไม่ถูกต้อง</span
            >
          </div>
          <div class="vx-col md:w-1/3 w-full mt-5">
            <vs-input
              id="house_code_number"
              label="เลขรหัสประจำบ้าน"
              v-model="regisInfo.houseCodeNumber"
              class="w-full"
              name="house_code_number"
              placeholder="XXXX-XXXXXX-X"
              maxlength="13"
              @keyup="checkHouseCode()"
            />
            <!-- <span
              class="text-danger text-sm"
              v-show="errors.has('house_code_number')"
              >{{ errors.first("house_code_number") }}</span
            > -->
          </div>
          <!-- <div class="vx-col md:w-1/3 w-full mt-5">
              <vs-input
                label="ที่ตั้งสำนักงานใหญ่เลขที่"
                v-model="regisInfo.registrationOffice"
                class="w-full"
                v-validate="'required'"
                name="registration_office"
              />
              <span
              class="text-danger text-sm"
              v-show="errors.has('registration_office')"
              >{{ errors.first("registration_office") }}</span
              >
            </div> -->
            <div class="vx-col md:w-1/3 w-full mt-5">
              <vs-input
                label="ชื่ออาคาร"
                v-model="regisInfo.buildingName"
                class="w-full"
                name="building_name"
              />
            </div>
            <div class="vx-col md:w-1/3 w-full mt-5">
                <vs-input
                  label="เลขที่*"
                  v-model="regisInfo.address"
                  class="w-full"
                  name="address"
                />
              <span
              class="text-danger text-sm"
              v-show="errors.has('address')"
              >{{ errors.first("address") }}</span
              >
            </div>
            <div class="vx-col md:w-1/4 w-full mt-5">
              <vs-input
                label="ชั้นที่"
                v-model="regisInfo.floor"
                class="w-auto"
                name="floor"
              />
            </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="หมู่ที่*"
              v-model="regisInfo.villageNumber"
              class="w-auto"
              name="village_number"
            />
            <!-- <span
              class="text-danger text-sm"
              v-show="errors.has('village_number')"
              >{{ errors.first("village_number") }}</span
            > -->
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ตรอก/ซอย"
              v-model="regisInfo.lane"
              class="w-full"
              name="lane"
            />
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ถนน"
              v-model="regisInfo.road"
              class="w-full"
              name="road"
            />
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-select
              class="w-full select-large"
              label="จังหวัด*"
              v-model="regisInfo.province"
              @change="onProvince"
              name="province"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item.PROVINCE_NAME"
                v-for="(item, index) in provinceName"
                class="w-full"
              />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('province')">{{
              errors.first("province")
            }}</span>
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-select
              :disabled="!selectDistrict"
              class="w-full select-large"
              label="อำเภอ/เขต*"
              v-model="regisInfo.district"
              @change="onDistrict"
              name="district"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item.DISTRICT_NAME"
                v-for="(item, index) in districtName"
                class="w-full"
              />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('district')">{{
              errors.first("district")
            }}</span>
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-select
              :disabled="!selectSubDistrict"
              class="w-full select-large"
              label="ตำบล/แขวง*"
              v-model="regisInfo.subDistrict"
              @change="onSubDistrict"
              name="sub_district"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item.SUB_DISTRICT_NAME"
                v-for="(item, index) in subDistrictName"
                class="w-full"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('sub_district')"
              >{{ errors.first("sub_district") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="รหัสไปรษณีย์*"
              v-model="regisInfo.postalCode"
              class="w-full"
              name="postal_code"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('postal_code')"
              >{{ errors.first("postal_code") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="เบอร์โทรศัพท์*"
              v-model="regisInfo.phoneNumber"
              class="w-full"
              v-validate="'required|numeric|min:9'"
              maxlength="10"
              name="phone_number"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('phone_number')"
              >{{ errors.first("phone_number") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="อีเมล"
              v-model="regisInfo.email"
              class="w-full"
              v-validate="'email'"
              name="email"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
        </div>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content title="ตั้งรหัสผ่านเพือใช้งาน" class="mb-5">
        <div class="vx-row">
          <vs-row class="mt-5 mb-5">
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="3"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <h5 class="text-danger mt-5">
                (รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร)
              </h5>
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-input
                label="ชื่อผู้ใช้งาน"
                class="w-1/4"
                v-model="cardNumberCutDash"
                disabled
                v-validate="'required'"
                name="username"
              />
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <span
                class="text-danger text-sm"
                v-show="errors.has('username')"
                >{{ errors.first("username") }}</span
              >
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-input
                type="password"
                label="รหัสผ่าน*"
                class="w-1/4"
                v-model="regisInfo.password"
                v-validate="'required|min:8'"
                name="password"
              />
              <br />
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <span
                class="text-danger text-sm"
                v-show="errors.has('password')"
                >{{ errors.first("password") }}</span
              >
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-input
                type="password"
                label="ยืนยันรหัสผ่าน*"
                class="w-1/4"
                v-model="regisInfo.confirmPassword"
                v-validate="'required|min:8'"
                name="confirm_password"
              />
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <span
                class="text-danger text-sm"
                v-show="errors.has('confirm_password')"
                >{{ errors.first("confirm_password") }}</span
              >
            </vs-col>
            <!-- <vs-col
              class="mt-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-checkbox class="mt-5" v-model="isConfirm"
                >ยืนยันว่าข้อมูลถูกต้อง และเป็นความจริง</vs-checkbox
              >
            </vs-col> -->
          </vs-row>
        </div>
      </tab-content>
    </form-wizard>
  </vx-card>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Swal from "sweetalert2";

// For custom error message
import { Validator } from "vee-validate";
import { DICT_USER } from "../../../mock-data/form-validate.js";

import { PERSONTYPE } from "../../../constants/endpoint.js";
// register custom messages
Validator.localize("en", DICT_USER);
export default {
  components: {
    FormWizard,
    TabContent,
  },
  data() {
    return {
      regisInfo: {
        id: null,
        title:"",
        other:"",
        firstName: "",
        lastName: "",
        cardNumber: "",
        houseCodeNumber: "",
        registrationOffice: "",
        buildingName: "",
        address: "",
        floor: "",
        villageNumber: "",
        lane: "",
        road: "",
        province: "",
        district: "",
        subDistrict: "",
        postalCode: "",
        phoneNumber: "",
        email: "",
        username: "",
        password: "",
        confirmPassword: "",
        personType: "",
      },
      isConfirm: false,
      checkbox: {
        chkOther: false,
      },
      provinceName: [],
      districtName: [],
      subDistrictName: [],
      title:[
        {key:1,value:"นาย"},
        {key:2,value:"นาง"},
        {key:3,value:"นางสาว"},
        {key:4,value:"อื่นๆ"},
      ],
      zipCode: null,
      selectDistrict: false,
      selectSubDistrict: false,
      inputZipCode: false,
      url: null,
      cardNumber: "",
      toggleValidate: false,
      cardNumberCutDash:"",
      toggleOther:true,
      idCardImage: null,
    };
  },
  watch: {
  },
  mounted() {
    this.$store.dispatch("address/getProvince");

    this.provinceName = this.$store.state.address.provinceData;

    $(document).ready(function() {
      $("#card_id").bind("keypress", function(evt) {
        var key = String.fromCharCode(evt.which || evt.charCode);
        if (/[\d -]/.test(key) === false) return evt.preventDefault();
      });
    });
    $(function() {
      $("[id*=card_id]").on("keypress", function() {
        var number = $(this).val();
        if (number.length == 1) {
          $(this).val($(this).val() + "-");
        } else if (number.length == 6) {
          $(this).val($(this).val() + "-");
        } else if (number.length == 12) {
          $(this).val($(this).val() + "-");
        } else if (number.length == 15) {
          $(this).val($(this).val() + "-");
        }
      });
    });
  },
  methods: {
    formSubmitted() {
        let cutDash = this.cardNumber.split("-")
        let cardNum = `${cutDash[0]}${cutDash[1]}${cutDash[2]}${cutDash[3]}${cutDash[4]}`
        
      this.$validator.validateAll().then((result) => {
        if (result && this.toggleValidate != true) {
          if (this.regisInfo.password != this.regisInfo.confirmPassword) {
            Swal.fire({
              icon: "warning",
              title: "เกิดข้อผิดพลาด",
              text: "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน",
              showConfirmButton: false,
            });
          } else {
            (async () => {
              const title = this.regisInfo.title == "อื่นๆ" ? this.regisInfo.other : this.regisInfo.title;
              const houseCodeNumber = this.regisInfo.houseCodeNumber ? this.regisInfo.houseCodeNumber : '-' ;
              const buildingName = this.regisInfo.buildingName ? this.regisInfo.buildingName : '-' ;
              const floor = this.regisInfo.floor ? this.regisInfo.floor : '-';
              const villageNumber = this.regisInfo.villageNumber ? this.regisInfo.villageNumber : '-';
              const lane = this.regisInfo.lane ? this.regisInfo.lane : '-';
              const road = this.regisInfo.road ? this.regisInfo.road : '-';
              const email = this.regisInfo.email ? this.regisInfo.email : '-';
              console.log("this.regisInfo.district  ", this.regisInfo.district );
              console.log("this.regisInfo.subDistrict  ", this.regisInfo.subDistrict );
              const { value: accept } = await Swal.fire({
                title: 'ยินยอมข้อตกลง',
                html:
                  '<br/><hr/><br/><div style="font-size: 14px">' +
                  'ชื่อ : ' + title + this.regisInfo.firstName + ' ' + this.regisInfo.lastName +'<br/>' +
                  'เลขบัตรประชาชน : ' + this.formateCardNumber(cardNum) + '<br/>' +
                  'เลขรหัสประจำบ้าน : ' + houseCodeNumber + '<b style="margin-left: 20px;"></b>' + 'ชื่ออาคาร : ' + buildingName + '<br/>' + 
                  'เลขที่ : ' + this.regisInfo.address + '<b style="margin-left: 20px;"></b>' + 'ชั้นที่ : ' + floor + '<b style="margin-left: 20px;"></b>' + 'หมู่ที่ : ' + villageNumber + '<b style="margin-left: 20px;"></b>' + 'ตรอก/ซอย : ' + lane + '<b style="margin-left: 20px;"></b>'  + 'ถนน : ' + road +  '<br/>' +
                  'จังหวัด : ' + this.regisInfo.province.PROVINCE_NAME + '<b style="margin-left: 20px;"></b>' + 'อำเภอ/เขต : ' + this.regisInfo.district.DISTRICT_NAME + '<b style="margin-left: 20px;"></b>' + 'ตำบล/แขวง : ' + this.regisInfo.subDistrict.SUB_DISTRICT_NAME + '<b style="margin-left: 20px;"></b>' + 'รหัสไปรษณีย์ : ' + this.regisInfo.postalCode + '<br/>' + 
                  'เบอร์โทรศัพท์ : ' + this.regisInfo.phoneNumber + '<b style="margin-left: 20px;"></b>' + 'อีเมล : ' + email + '<br/>' + 
                  '</div><br/><hr/><br/>' +
                  '<p style="padding: 5px 10px 5px 10px; font-size: 13px">ข้าพเจ้าขอรับรองว่าข้อความในแบบคำขอที่ยื่นมานี้มีความถูกต้องและเป็นจริงทุกประการ ตลอดจนจะปฏิบัติตามกฎหมายและระเบียบของทางราชการทุกประการ และเมื่อได้รับการติดตั้งอุปกรณ์ระบบสำแดงข้อมูลตัวตนอัตโนมัติ (Automatic Identification System : AIS) จากกรมสรรพสามิตแล้ว ข้าพเจ้าจะดูแลรักษาอุปกรณ์ระบบฯ ดังกล่าวเป็นอย่างดี และหากเกิดการชำรุดเสียหายอันเกิดจากความประมาทเลินเล่อในการปฏิบัติงาน ข้าพเจ้ายินยอมชดใช้ค่าเสียหายและค่าซ่อมแซมอุปกรณ์ระบบฯ ให้แก่กรมสรรพสามิต</p>',
                input: 'checkbox',
                inputValue: 0,
                inputPlaceholder: 'ยืนยันว่าข้อมูลถูกต้องและเป็นความจริง',
                confirmButtonText: 'ยืนยัน',
                confirmButtonColor: '#3085d6',
                showCancelButton: true,
                cancelButtonText: 'ยกเลิก',
                width: 900,
                padding: 20,
                inputValidator: (result) => {
                  return !result && 'กรุณายืนยันว่าข้อมูลถูกต้องและเป็นความจริง'
                }
              })
              if (accept) {
                const province = this.regisInfo.province;
                const district = this.regisInfo.district;
                const subDistrict = this.regisInfo.subDistrict;
                var payload = {
                  title: this.regisInfo.title == "อื่นๆ" ? this.regisInfo.other : this.regisInfo.title,
                  firstName: this.regisInfo.firstName,
                  lastName: this.regisInfo.lastName,
                  cardNumber: cardNum,
                  houseCodeNumber: this.regisInfo.houseCodeNumber,
                  registrationOffice: this.regisInfo.registrationOffice,
                  buildingName: this.regisInfo.buildingName,
                  address: this.regisInfo.address,
                  floor: this.regisInfo.floor,
                  villageNumber: this.regisInfo.villageNumber,
                  lane: this.regisInfo.lane,
                  road: this.regisInfo.road,
                  province: province ? province.PROVINCE_NAME : "",
                  district: district ? district.DISTRICT_NAME : "",
                  subDistrict: subDistrict
                    ? subDistrict.SUB_DISTRICT_NAME
                    : "",
                  postalCode: this.regisInfo.postalCode,
                  phoneNumber: this.regisInfo.phoneNumber,
                  email: this.regisInfo.email,
                  username: cardNum,
                  password: this.regisInfo.password,
                  confirmPassword: this.regisInfo.confirmPassword,
                  personType: PERSONTYPE.OWNER,
                  idCardImageFile: this.idCardImageFile
                };
                console.log("this is payload :", payload);
                this.$store.dispatch("users/setInsertUser", payload)
              }
            })()
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "เกิดข้อผิดพลาด",
            text: "กรุณากรอกข้อมูลให้ถูกต้อง",
            showConfirmButton: false,
          });
        }
      });
    },
    onProvince() {
      const province = this.regisInfo.province;
      this.$store.dispatch("address/selectProvince",province ? province.PROVINCE_ID : ""
      );
      this.districtName = this.$store.state.address.districtData;
      this.selectDistrict = true;
    },
    onDistrict() {
      const district = this.regisInfo.district;
      this.$store.dispatch("address/selectDistrict",district ? district.DISTRICT_ID : "");
      this.subDistrictName = this.$store.state.address.subDistrictData;
      this.selectSubDistrict = true;
    },
    onSubDistrict() {
      const subDistrict = this.regisInfo.subDistrict;
      this.$store.dispatch("address/selectSubDistrict",subDistrict ? subDistrict.SUB_DISTRICT_ID : "");
      this.regisInfo.postalCode = this.$store.state.address.zipCodeData;
      this.inputZipCode = true;
    },
    async onChangeIdCardImage(e){
      const file = e.target.files[0];
      this.idCardImage = URL.createObjectURL(file);
      this.idCardImageFile = file;
      // await this.$store.dispatch("users/setOCR",this.idCardImageFile)
    },
    async OCR(){
      this.$vs.loading({});
      const loading = this.$store.state.users.loading
      await this.$store.dispatch("users/setOCR",this.idCardImageFile);
      const ocrData = this.$store.state.users.ocr;
      // console.log("users.ocr =>>>> ", ocrData);
      // console.log("text.split ", ocrData.Identification_Number.replace(/\s+/g, ''));
      this.regisInfo.title =  ocrData.PrefixTH ? ocrData.PrefixTH : ocrData.PrefixEN == "Mrs." ? "นาง" : ocrData.PrefixEN == "Miss." ? "นางสาว" : ocrData.PrefixEN == "Mr." ? "นาย" : "อื่นๆ";
      this.regisInfo.firstName =  ocrData.NameTH;
      this.regisInfo.lastName =  ocrData.LastNameTH;

      const cardNumber = ocrData.Identification_Number.replace(/\s+/g, '');
      this.cardNumber = this.formateCardNumber(cardNumber)
      
      !loading && this.$vs.loading.close();
    },
    formateCardNumber(cardNumber){
      return cardNumber && `${cardNumber.substring(0,1)}-${cardNumber.substring(1,2)}${cardNumber.substring(2,3)}${cardNumber.substring(3,4)}${cardNumber.substring(4,5)}-${cardNumber.substring(5,6)}${cardNumber.substring(6,7)}${cardNumber.substring(7,8)}${cardNumber.substring(8,9)}${cardNumber.substring(9,10)}-${cardNumber.substring(10,11)}${cardNumber.substring(11,12)}-${cardNumber.substring(12,13)}`
    },
    checkCardNumber() {
      var total = 0;
      var iPID;
      var chk;
      var Validchk;
      iPID = this.cardNumber.replace(/-/g, "");
      Validchk = iPID.substr(12, 1);
      var j = 0;
      var pidcut;
      for (var n = 0; n < 12; n++) {
        pidcut = parseInt(iPID.substr(j, 1));
        total = total + pidcut * (13 - n);
        j++;
      }

      chk = 11 - (total % 11);

      if (chk == 10) {
        chk = 0;
      } else if (chk == 11) {
        chk = 1;
      }
      // console.log("this.cardNumber ", this.cardNumber.length);
      if (!this.toggleValidate) {
        if (chk == Validchk) {
          this.toggleValidate = false;
          this.formSubmitted();
          return true;
        } else {
          this.formSubmitted();
          this.toggleValidate = true;
          return false;
        }
      } else {
        if (chk == Validchk) {
          this.toggleValidate = false;
          return true;
        } else {
          this.toggleValidate = true;
          return false;
        }
      }
      
    },
    onOther(){ 
      console.log("this is other", this.regisInfo.title);
      if(this.regisInfo.title == "อื่นๆ"){ 
        this.toggleOther = false
      }else{ 
        this.toggleOther = true
      }
    },
    checkHouseCode(){
      $("[id*=house_code_number]").on("keypress", function() {
        let value = $(this).val();
        if (value.length == 4) {
          $(this).val($(this).val() + "-");
        } else if (value.length == 11) {
          $(this).val($(this).val() + "-");
        }
      });
    },
  },
  watch:{ 
    cardNumber: function() {
        let cutDash = this.cardNumber.split("-")
        let cardNum = `${cutDash[0]}${cutDash[1]}${cutDash[2]}${cutDash[3]}${cutDash[4]}`
        this.cardNumberCutDash = cardNum
    },
  }
};
</script>
<style lang="css" scoped>
.box {
  padding:10px 10px 10px 10px;
  width: 400px;
  height: 250px;
  border-style: dotted;
  border-color: #0984e3;
}
.img-show{
  max-width: 100%;
  height: 225px;
}
.alert{
  font-size: 15px;
}
</style>
